import { render, staticRenderFns } from "./AccreditationInviteContainer.vue?vue&type=template&id=ad4a6b8c&scoped=true"
import script from "./AccreditationInviteContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationInviteContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationInviteContainer.vue?vue&type=style&index=0&id=ad4a6b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4a6b8c",
  null
  
)

export default component.exports